function updateNetworkBadge(uid, uplink, downlink) {
  if (uplink == 0 && downlink == 0) return;
  var tier =
    uplink <= 2 && downlink <= 2
      ? "great"
      : uplink < 5 && downlink < 5
        ? "okay"
        : "poor";
  const row = $("#user-row-" + uid);
  row.find(".network").hide();
  row.find(".network-" + tier).css("display", "inline-block");
}

export default class AgoraChannel {
  constructor() {}

  async connectAgoraDevices() {
    // optimizationMode: "detail"

    // why check this if microphone_config already checks?
    if (currentMic) {
      await AgoraRTC.createMicrophoneAudioTrack(Devices.microphone_config)
        .then((track) => {
          localTracks.audioTrack = track;
          if (currentSpeaker) {
            // localTracks.audioTrack.setPlaybackDevice(currentSpeaker.deviceId)
            // .catch(error => {
            //   console.log("could not setPlaybackDevice 3" + error.message)
            // })
          }
        })
        .catch((error) => {
          if (
            error.toString().includes("PERMISSION_DENIED") ||
            error.toString().includes("Permission denied")
          ) {
            console.log("agora_capture_failure1A " + error.message);
          } else {
            console.error("agora_capture_failure1 " + error.message);
            // alert(error.message)
          }
        });
    }

    if (currentCam) {
      await AgoraRTC.createCameraVideoTrack({ cameraId: currentCam.deviceId })
        .then((track) => {
          localTracks.videoTrack = track;
          localTracks.videoTrack.play("pre-local-player");
          $("#pre-local-player").click();
          localTracks.videoTrack.setEncoderConfiguration("360p_8");
        })
        .catch((error) => {
          if (
            error.toString().includes("PERMISSION_DENIED") ||
            error.toString().includes("Permission denied")
          ) {
            console.log("agora_capture_failure2A " + error.message);
          } else {
            console.error("agora_capture_failure2 " + error.message);
            // alert(error.message)
          }
        });
    }

    $(".agora_video_player")
      .parent()
      .addClass("rounded-xl")
      .css("background-color", "#ffffff00");
  }

  async handleLocalNetworkQuality(stats) {
    var uid = $("#attendee_id").val();

    updateNetworkBadge(
      uid,
      stats["uplinkNetworkQuality"],
      stats["downlinkNetworkQuality"],
    );
  }

  async updateRemoteNetworkQuality() {
    var network_qualities = client.getRemoteNetworkQuality();
    for (var uid in network_qualities) {
      updateNetworkBadge(
        uid,
        network_qualities[uid]["uplinkNetworkQuality"],
        network_qualities[uid]["downlinkNetworkQuality"],
      );
    }
  }

  async join() {
    Rails.ajax({
      url: `/${subscription_id}/attendee/${$("#attendee_id").val()}/update_meta.js`,
      type: "patch",
      error: function (xhr, status, error) {
        console.error("Failed to update attendee meta on join:", error);
        Rollbar.warning("agora_join_update_meta_failed", {
          status,
          error: error.toString(),
        });
      },
    });
    if (localTracks.videoTrack) {
      if (localTracks.videoTrack._enabled) {
        localTracks.videoTrack.play(`player-${options.uid}`);
      } else {
        PlayerOptions.addCameraOffIcon($(`#player-${options.uid}`));
      }
    } else {
      PlayerOptions.addCameraOffIcon($(`#player-${options.uid}`));
    }
    PlayerOptions.addName($(`#player-${options.uid}`), options.uid);
    PlayerOptions.addOption($(`#player-${options.uid}`));
    FixVideos.fix_resolution();

    if (localTracks.audioTrack) {
      if (!localTracks.audioTrack._enabled) {
        FixVideos.show_mute_attendee_icon(options.uid);
      }
    } else {
      FixVideos.show_mute_attendee_icon(options.uid);
    }

    // setTimeout(function(){ Room.check_connection() }, 5000);
    await Room.join_channel();

    $("#name_setting").trigger("keyup");
    if ($("#show_recording").length) {
      var show_already_recording = true;
      Room.show_now_recording(show_already_recording);
      $("#show_recording").remove();
    }
    // $("#invite_button").click() //show invite modal by default
    if ($("#is_host").length > 0) {
      clearInterval(this._networkQualityInterval);
      this._networkQualityInterval = setInterval(
        this.updateRemoteNetworkQuality,
        2000,
      );
    }

    // AUTO_SIMULCAST_MODE (-1): low stream is only sent when a receiver requests it,
    // rather than always sending both streams. More efficient than enableDualStream().
    client
      .setDualStreamMode(-1)
      .catch((e) => console.warn("setDualStreamMode failed:", e));
  }

  async handleUserJoined(user) {
    console.log("user joined---");
    const uid = user.uid;
    if ($(`#user-row-${uid}`).length == 0) {
      $("#participant_rows").append($("#participant_row_template").html());
      var new_user_row = $("#participant_rows li").last();
      $(new_user_row).attr("id", $(new_user_row).attr("id") + uid);
    }

    Rails.ajax({
      url: `/${subscription_id}/attendee/${uid}/name.js`,
      type: "get",
      error: function (xhr, status, error) {
        console.error(`Failed to fetch name for user ${uid}:`, error);
        Rollbar.warning("agora_fetch_user_name_failed", {
          uid,
          status,
          error: error.toString(),
        });
      },
    });
    remoteUsers[uid] = user;
  }
  async handleUserLeft(user) {
    console.log("-----------------------------------------------user left---");

    const id = user.uid;
    VolumeMeter.unbindRemote(id);
    if (
      screenShareUsers.includes(id) ||
      (!user.hasAudio &&
        !user.hasVideo &&
        user._audio_muted_ == false &&
        user._video_muted_ == false)
    ) {
      $(`#player-${id}, #user-row-${id}`).remove();
      delete remoteUsers[id];

      if (id == maximized_uid) {
        console.log("set normal");
        FixVideos.setNormal();
      } else if (maximized_uid) {
        console.log("set maximize");
        setTimeout(function () {
          FixVideos.maximize(maximized_uid);
        }, 500);
      } else {
        FixVideos.fix_resolution();
      }
    }
  }

  async handleUserPublished(user, mediaType) {
    const uid = user.uid;
    await client.subscribe(user, mediaType);
    console.log(`:handleUserPublished start ${user.uid} ${mediaType}`);
    // console.log(mediaType)

    //can we do this with user joined now?
    // if ($(`#user-row-${uid}`).length == 0 ){
    //   $("#participant_rows").append($("#participant_row_template").html())
    //   var new_user_row = $("#participant_rows li").last()
    //    $(new_user_row).attr("id", $(new_user_row).attr("id") + uid)
    // }

    remoteUsers[uid] = user;
    var player = undefined;

    if ($(`#player-${uid}`).length == 0) {
      player = $(
        `<div id="player-${uid}" class="player shadow-lg inset-0 bg-gradient-to-br from-gray-900 via-black to-indigo-900" style="position:relative;height:100%"></div>`,
      );
      $("#players_container").append(player);
    } else {
      player = $(`#player-${uid}`);
    }

    if (mediaType === "video") {
      if (user.videoTrack) {
        await user.videoTrack.play(`player-${uid}`);
        var video_player = player.find("video").parent();
        PlayerOptions.addName(player, uid);
        PlayerOptions.addOption(player);
        player.find(".video_camera_off_icon").remove();
      }
    }

    if (mediaType === "audio") {
      var screen_client_uid = (screenClient || {}).uid;
      if (screen_client_uid == uid) {
        user.audioTrack.setVolume(0);
        console.log("set volume to 0 since local screen share volume");
      } else {
        if (user.audioTrack) {
          user.audioTrack.play();
          if (currentSpeaker) {
            user.audioTrack
              .setPlaybackDevice(currentSpeaker.deviceId)
              .catch((error) => {
                console.error("could not setPlaybackDevice" + error.message);
              });
          }
        }
      }

      if (user._video_added_ == false) {
        //they are not using video but still want to show video block
        PlayerOptions.addName(player, uid);
        PlayerOptions.addOption(player);
        PlayerOptions.addCameraOffIcon(player);
      }

      if ($("#is_host").length > 0) {
        if (user.audioTrack) {
          var user_stream = new MediaStream();
          user_stream.addTrack(user.audioTrack.getMediaStreamTrack());
          VolumeMeter.remoteBind(user_stream, uid);
        }
      }
    }

    FixVideos.fix_resolution();
    Rails.ajax({
      url: `/${subscription_id}/attendee/${uid}/name.js`,
      type: "get",
      error: function (xhr, status, error) {
        console.error(`Failed to fetch name for published user ${uid}:`, error);
        Rollbar.warning("agora_user_published_fetch_name_failed", {
          uid,
          status,
          error: error.toString(),
        });
      },
    });

    var recording_id = parseInt(
      $("[data-recording-id]").attr("data-recording-id"),
    );
    if (recording_id) {
      Rails.ajax({
        url: `/recordings/${recording_id}/attendee/${uid}/recording_status.js`,
        type: "patch",
        error: function (xhr, status, error) {
          console.error(`Failed to update recording status for ${uid}:`, error);
          Rollbar.warning("agora_update_recording_status_failed", {
            uid,
            recording_id,
            status,
            error: error.toString(),
          });
        },
      });
    }
    if (maximized_uid) {
      FixVideos.maximize(maximized_uid);
    }
  }

  handleUserUnpublished(user, mediaType) {
    console.log(":handleUserUnpublished");
    // console.log("user unpublished")
    // console.log(user)
    // console.log(user.audioTrack)
    // console.log(user.videoTrack)
    // console.log(user._audio_muted_)
    // console.log(user._video_muted_)
    // can we check if they disabled vs unpublished/left?

    const id = user.uid;
    // if (mediaType == 'video'){

    if (
      screenShareUsers.includes(id) ||
      (!user.hasAudio &&
        !user.hasVideo &&
        user._audio_muted_ == false &&
        user._video_muted_ == false)
    ) {
      // screenShareUsers.pop(id)
      console.log("NORMALLY WOULD BUT I WONT remove user---");
      // $(`#player-${id}, #user-row-${id}`).remove();
      // delete remoteUsers[id];
    } else if (
      all_producer_roles.includes(id) &&
      user._audio_muted_ == true &&
      user._video_muted_ == true
    ) {
      console.log("remove producer---");
      $(`#player-${id}`).remove();
      FixVideos.fix_resolution();
      setTimeout(function () {
        FixVideos.fix_resolution();
      }, 500);
    } else {
      console.log("dont remove user ---");
      //the video has been removed by agora so add back username and options
      const player = $(`#player-${id}`);
      PlayerOptions.addName(player, id);
      PlayerOptions.addOption(player);
      if (mediaType == "video") {
        PlayerOptions.addCameraOffIcon(player);
      }
      Rails.ajax({
        url: `/${subscription_id}/attendee/${id}/name.js`,
        type: "get",
        error: function (xhr, status, error) {
          console.error(
            `Failed to fetch name for unpublished user ${id}:`,
            error,
          );
          Rollbar.warning("agora_user_unpublished_fetch_name_failed", {
            id,
            status,
            error: error.toString(),
          });
        },
      });
      var recording_id = parseInt(
        $("[data-recording-id]").attr("data-recording-id"),
      );
      if (recording_id) {
        Rails.ajax({
          url: `/recordings/${recording_id}/attendee/${id}/recording_status.js`,
          type: "patch",
          error: function (xhr, status, error) {
            console.error(
              `Failed to update recording status for unpublished ${id}:`,
              error,
            );
            Rollbar.warning(
              "agora_unpublished_update_recording_status_failed",
              { id, recording_id, status, error: error.toString() },
            );
          },
        });
      }
    }
    // }
    if (id == maximized_uid) {
      console.log("set normal");
      FixVideos.setNormal();
    } else if (maximized_uid) {
      console.log("set maximize");
      FixVideos.maximize(maximized_uid);
    }

    FixVideos.fix_resolution();
    setTimeout(function () {
      FixVideos.fix_resolution();
    }, 500);
  }

  async connectionStateChanged(curState, prevState, reason) {
    console.log(
      `Connection state changed: ${prevState} -> ${curState}, reason: ${reason}`,
    );

    try {
      if (curState === "RECONNECTING") {
        console.log("Reconnecting to Agora channel...");
        Rollbar.warning("agora_connection_lost", {
          prevState,
          curState,
          reason,
        });
        // Show reconnecting overlay so user knows what's happening
        if (!document.getElementById("reconnecting-overlay")) {
          const overlay = document.createElement("div");
          overlay.id = "reconnecting-overlay";
          overlay.style.cssText =
            "position:fixed;bottom:16px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.75);color:#fff;padding:8px 16px;border-radius:8px;font-size:14px;z-index:9999;";
          overlay.textContent = "Reconnecting...";
          document.body.appendChild(overlay);
        }
      } else if (curState === "CONNECTED") {
        console.log("Successfully connected to Agora channel");
        const overlay = document.getElementById("reconnecting-overlay");
        if (overlay) overlay.remove();
      } else if (curState === "DISCONNECTED") {
        const overlay = document.getElementById("reconnecting-overlay");
        if (overlay) overlay.remove();
      }
    } catch (error) {
      console.error("Error in connectionStateChanged handler:", error);
      Rollbar.error("agora_connection_state_change_error", error.message);
    }
  }
}
